/* webpack-strip-block:removed */

export default {
  data: () => ({
    tag: "",
    tags: [],
    ms_tag_values: [],
    feed_type: null,
    feed_types: [],
    auto_complete_tags: [],
    selected_artwork: null,
    selected_banner_artwork: null,
    feed: {
      name: "Untitled",
      description: "",
      import_url: null,
      ordering: 1,
      sync_to_website: false,
    },
  }),
  mounted() {
    EventBus.$on('new_artwork_selected', (payload) => {
      toastr.success("New Artwork Selected.");
      this.selected_artwork = payload;
    });

    if (window.feed) {
      this.selected_artwork = window.feed.artwork;
    }
  },
  methods: {
    /**
     * Fetches all tags for this customer, and assigns this array to `auto_complete_tags`.
     *
     * The tags are just the tag names; This is so the multiselect can create its own tags.
     */
    async getAllTags() {
      try {
        this.auto_complete_tags = (await axios.get(`/api/v1/tags`)).data.data?.map(tag => tag.name);
      } catch (error) {
        window.handleAxiosError(error);
      }
    },
    /**
     * Fetches all _enabled_ feed types, and assigns this array to `feed_types`.
     *
     * If the user is a super admin, all types are returned.
     */
    async getFeedTypes() {
      try {
        KTApp.blockPage();
        const response = await axios.get("/api/v1/feeds/types");
        this.feed_types = response.data.data;
        if (this.feed && this.feed.feed_type) {
          this.feed_type = _.find(this.feed_types, feed_type => feed_type.id === this.feed.feed_type.id);
        }
        KTApp.unblockPage();
      } catch (error) {
        window.handleAxiosError(error);
      }
    },
  },
  computed: {
    artwork_to_display() {
      if (this.selected_artwork) {
        return this.selected_artwork;
      }

      if (this.feed.artwork) {
        return this.feed.artwork;
      }

      return null;
    },
    banner_to_display() {
      return this.selected_banner_artwork ?? null;
    },
  },
};
